import { JupiterTheme, MockHook } from '@jupiterone/jupiter-web-toolkit';
import { createStyles, makeStyles } from '@material-ui/styles';
import React from 'react';
import useSearchAnywereIconLogic, {
  SearchAnywhereIconComponentProps,
} from './useSearchAnywhereIconLogic';
import clsx from 'clsx';
import { Tooltip } from '@material-ui/core';

const useStyles = makeStyles((theme: JupiterTheme) => {
  return createStyles({
    searchAnywhereIconRoot: {
      height: 44,
      width: 67,
      position: 'relative',
      cursor: 'pointer',
      stroke: '#6199EC',
      '&:hover': {
        stroke: theme.palette.primary.main,
      },
    },
    activeIconBackdropContainer: {
      height: 39,
      width: 39,
      borderRadius: '50%',
      background: '#53D5BB',
      position: 'absolute',
      marginLeft: 14,
      marginTop: 2.5,
    },
    activeIconContainer: {
      position: 'absolute',
      top: 10,
      left: 21,
      height: 28,
      width: 28,
      '& svg': {
        marginLeft: '0!important',
      },
    },
    svgActiveRoot: {
      stroke: theme.palette.common.white,
    },
    svgInactiveRoot: {
      '&:hover': {
        stroke: theme.palette.primary.main,
      },
    },
  });
});

export const SearchAnywereIconComponent = ({
  searchAnywhereOpen,
  handleSearchAnywhereToggle,
}: SearchAnywhereIconComponentProps) => {
  const classes = useStyles();
  return (
    <Tooltip title="Query Anywhere" enterDelay={300}>
      <div
        onClick={handleSearchAnywhereToggle}
        className={classes.searchAnywhereIconRoot}
        data-testid="navbar-search-anywhere-icon"
      >
        {searchAnywhereOpen && (
          <div className={classes.activeIconBackdropContainer}></div>
        )}
        <div className={classes.activeIconContainer}>
          <svg
            width="25"
            height="25"
            viewBox="0 0 26 26"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <line
              x1="17"
              y1="7.91895"
              x2="23.625"
              y2="7.91895"
              className={clsx(
                searchAnywhereOpen
                  ? classes.svgActiveRoot
                  : classes.svgInactiveRoot
              )}
              strokeWidth="1.5"
              strokeLinecap="round"
            />
            <line
              x1="3.75"
              y1="5.25098"
              x2="13.25"
              y2="5.25098"
              className={clsx(
                searchAnywhereOpen
                  ? classes.svgActiveRoot
                  : classes.svgInactiveRoot
              )}
              strokeWidth="1.5"
              strokeLinecap="round"
            />
            <line
              x1="1.83105"
              y1="9"
              x2="6.83105"
              y2="9"
              className={clsx(
                searchAnywhereOpen
                  ? classes.svgActiveRoot
                  : classes.svgInactiveRoot
              )}
              strokeWidth="1.5"
              strokeLinecap="round"
            />
            <path
              d="M23.5625 18.9561C23.5625 18.9561 22.75 18.9561 20.8542 18.9561C18.9583 18.9561 18.4167 21.3936 15.1667 21.3936C11.9167 21.3936 11.6458 18.9561 9.75 18.9561C7.85416 18.9561 7.04166 18.9561 7.04166 18.9561"
              className={clsx(
                searchAnywhereOpen
                  ? classes.svgActiveRoot
                  : classes.svgInactiveRoot
              )}
              strokeWidth="1.5"
              strokeLinecap="round"
            />
            <path
              d="M4.875 15.1689C4.875 15.1689 7.58333 15.1689 9.47917 15.1689C11.375 15.1689 11.9167 12.7314 15.1667 12.7314C18.4167 12.7314 18.6875 15.1689 20.5833 15.1689C22.4792 15.1689 24.9167 15.1689 24.9167 15.1689"
              className={clsx(
                searchAnywhereOpen
                  ? classes.svgActiveRoot
                  : classes.svgInactiveRoot
              )}
              strokeWidth="1.5"
              strokeLinecap="round"
            />
            <circle
              cx="13"
              cy="13"
              r="12.25"
              className={clsx(
                searchAnywhereOpen
                  ? classes.svgActiveRoot
                  : classes.svgInactiveRoot
              )}
              strokeWidth="1.5"
            />
          </svg>
        </div>
      </div>
    </Tooltip>
  );
};

export default MockHook.withHookHoc(
  SearchAnywereIconComponent,
  useSearchAnywereIconLogic
);
